module.exports = __webpack_public_path__ + "img/avatar-luky-primadani.56302a59.jpg";